import { grey } from 'src/theme/palette';

export const unableToContactBoxFirstStyle = {
    padding: '12px 0',
    cursor: 'pointer',
    margin: '0'
};
export const unableToContactTitleStyle = {
    marginBottom: '16px',
    pb: '8px',
    fontWeight: 600,
    fontSize: '16px',
    color: 'text.secondary',
};
export const notesTitleStyle = {
    marginBottom: '10',
    pb: 0,
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
};
export const unableToContactBoxSecStyle = {
    padding: '0 8px',
    cursor: 'pointer',
    margin: '4px'
};
export const unableToContactBoxThirdStyle = {
    padding: '12px 8px',
    cursor: 'pointer',
    margin: '4px',
    position: 'relative'
};
export const sendEmailBoxStyle = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%'
};
export const sendEmailBoxCountStyle = email => ({
    background: email ? '#cbcbcb' : 'none',
    border: '1px solid #cbcbcb',
    padding: '0px 6px',
    marginRight: '10px',
    borderRadius: '5px',
    fontSize: '15px'
});
export const sendEmailBoxCountSecStyle = reminder => ({
    background: reminder ? '#cbcbcb' : 'none',
    border: '1px solid #cbcbcb',
    padding: '0px 6px',
    marginRight: '10px',
    borderRadius: '5px',
    fontSize: '15px'
});
export const sendEmailTitleStyle = {
    marginBottom: '10',
    pb: 0,
    fontWeight: 600,
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between !important',
    cursor: 'pointer',
    width: '100%',
    color: 'text.primary',
    transition: 'color 0.2s ease',
    '&:hover': {
        color: 'primary.main',
    }
};
export const noteBoxStyle = (selectedOptions, note) => ({
    color: selectedOptions.includes(note.value) ? '#fff' : '#637381',
    bgcolor: selectedOptions.includes(note.value) ? '#00A76F' : 'transparent',
    border: selectedOptions.includes(note.value) ? '1px solid #00A76F' : '1px solid rgba(145, 158, 171, 0.32)',
    borderRadius: '50px',
    p: '5px 14px',
    width: 'auto',
    display: 'inline-flex',
    m: '0 8px 8px 0',
    fontSize: '13px',
    fontWeight: 500,
    transition: 'all 0.2s ease',
    cursor: 'pointer',
    '&:hover': {
        borderColor: '#00A76F',
        color: selectedOptions.includes(note.value) ? '#fff' : '#00A76F',
    }
});
export const saveNoteButtonStyle = {
    textTransform: 'none !important',
    p: '8px 16px',
};
export const emailSuccessBoxStyle = {
    margin: '0px',
    background: 'rgba(0, 171, 85, 0.08)',
    borderRadius: 1.5,
    p: '6px 12px',
    fontSize: '13px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    color: '#007867',
};
export const emailSuccessIconBoxStyle = {
    width: 24,
    height: 24,
    borderRadius: '12px',
    background: '#54D62C29',
    mr: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};
export const contactOptionBoxInnerStyle = {
    backgroundColor: '#F4F6F8',
    p: 2,
    borderRadius: 2,
    mb: 1,
    mt: 1,
    width: '100%',
    display: 'inline-block',
    breakInside: 'avoid'
};
export const optionBoxStyle = {
    height: 48,
    backgroundColor: '#00A76F14',
    display: 'flex',
    borderRadius: 1,
    p: '11px 16px',
    alignItems: 'center',
    float: 'left',
    color: '#007867',
    mb: '12px',
    position: 'relative',
    pl: '40px'
};
export const noteMainBoxStyle = {
    display: 'block',
    bgcolor: '#F9FAFB',
    border: '1px solid rgba(0, 167, 111, 0.16)',
    borderRadius: '10px',
    position: 'relative',
};
export const openTaskPopupStyle = {
    border: '1px dashed rgba(145, 158, 171, 0.24)',
    borderRadius: '100px',
    width: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgcolor: grey[200]
};

/* Progress bar */
export const progressBarContainerStyle = (completedCount) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 14px',
    background: completedCount === 4 ? 'rgba(0,167,111,0.02)' : 'rgba(145,158,171,0.04)',
    border: completedCount === 4 ? '1px solid rgba(0,167,111,0.15)' : '1px solid rgba(145,158,171,0.08)',
    borderRadius: '8px',
    marginBottom: '20px',
});
export const progressBarTextStyle = (completedCount) => ({
    fontSize: '12px',
    fontWeight: 600,
    color: completedCount === 4 ? '#007867' : '#637381',
    whiteSpace: 'nowrap',
});
export const progressBarTrackStyle = {
    flex: 1,
    height: '5px',
    background: '#DFE3E8',
    borderRadius: '3px',
    overflow: 'hidden',
};
export const progressBarFillStyle = (percent) => ({
    height: '100%',
    width: `${percent}%`,
    background: '#00AB55',
    borderRadius: '3px',
    transition: 'width 0.3s ease',
});

/* Status badges */
export const statusBadgeDoneStyle = {
    padding: '3px 8px',
    borderRadius: '5px',
    fontSize: '11px',
    fontWeight: 600,
    background: 'rgba(0,167,111,0.08)',
    color: '#007867',
    flexShrink: 0,
};
export const statusBadgeOptionalStyle = {
    padding: '3px 8px',
    borderRadius: '5px',
    fontSize: '11px',
    fontWeight: 600,
    background: 'rgba(145,158,171,0.1)',
    color: '#919EAB',
    flexShrink: 0,
};
export const statusBadgeRecommendedStyle = {
    padding: '3px 8px',
    borderRadius: '5px',
    fontSize: '11px',
    fontWeight: 600,
    background: 'rgba(255,171,0,0.08)',
    color: '#B76E00',
    flexShrink: 0,
};

/* Success banners */
const successBannerBase = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '8px',
    padding: '10px 14px',
    margin: '8px 0 4px',
};
export const successBannerGreenStyle = {
    ...successBannerBase,
    background: 'rgba(0,167,111,0.05)',
    border: '1px solid rgba(0,167,111,0.12)',
};
export const successBannerBlueStyle = {
    ...successBannerBase,
    background: 'rgba(7,141,238,0.04)',
    border: '1px solid rgba(7,141,238,0.1)',
};
export const successBannerWaStyle = {
    ...successBannerBase,
    background: 'rgba(37,211,102,0.04)',
    border: '1px solid rgba(37,211,102,0.1)',
};
const successBannerCheckBase = {
    width: '22px',
    height: '22px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
};
export const successBannerCheckGreenStyle = {
    ...successBannerCheckBase,
    background: '#00AB55',
};
export const successBannerCheckBlueStyle = {
    ...successBannerCheckBase,
    background: '#078DEE',
};
export const successBannerCheckWaStyle = {
    ...successBannerCheckBase,
    background: '#25D366',
};
export const successBannerTextStyle = {
    fontSize: '13px',
    fontWeight: 600,
    color: '#212B36',
};